import React from 'react';
import Spin from 'antd/lib/spin';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import classNames from 'classnames';
import styles from './spinner.module.css';

interface Props {
	children?: React.ReactNode;
	loading?: boolean;
	wrapperClassName?: string;
	size?: 'small' | 'default' | 'large';
}

const Spinner = (props: Props): React.JSX.Element => {
	return (
		<Spin
			indicator={<LoadingOutlined />}
			spinning={props.loading}
			className={styles.Container}
			size={props.size || 'default'}
			wrapperClassName={props.wrapperClassName}
		>
			{props.children}
		</Spin>
	);
};

export default Spinner;
